import { isTest } from "../../lib/constants"
import { prefersReducedMotion } from "../../lib/helpers"

// By default, all tests will treat <TransitionGroup> as `disableAnimations={true}`,
// removing the need to be aware of misc. async animations happening across tests.
export default () => isTest || prefersReducedMotion()
